(function() {
    /** @ngInject */
    function Utils($http) {
        return {
            setCookie: function (key, value, days, path) {
                days = _.isUndefined(days) ? 10 : days;
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                var expires = "; expires=" + date.toGMTString();
                var dir = '/booking-widget';
                document.cookie = key + "=" + value + expires + "; path=" + dir;
                return true;
            },
            getCookie: function (key, defaultValue) {
                defaultValue = _.isUndefined(defaultValue) ? false : defaultValue;
                var nameEQ = key + "=";
                var cookies = document.cookie;
                if (_.size(cookies) > 0)
                    cookies = cookies.split(';');
                if (_.size(cookies) == 0) return defaultValue;
                for (var i in cookies) {
                    var c = cookies[i];
                    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
                }
                return defaultValue;
                //return _.has($cookies, key) ? $cookies[key] : defaultValue;
            },
            callAPI: function (path, params) {
                return $http.post("/booking-widget/apiv2/" + path, params);
            },
            checkResponse: function (response) {
                if (!response || !response.data.success) return false;
                if (response.data.success !== true) return false;
                return true;
            }
        }
    }
    angular.module("Waiteraid").factory("Utils", Utils);
    angular.module("Waiteraid").constant("Today", moment.tgz(_.parseInt(midnight) * 1000));
})();
